"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
/**
 * get URL from queryObject
 * @param {Object} queryObj
 * @returns {String}
 */
function getUrlFromQuery(queryObj) {
    return Object.keys(queryObj)
        .map((k) => `${k}=${queryObj[k]}`)
        .join('&');
}
exports.default = getUrlFromQuery;
